import config from '../../config/config';

export const loadGalleryImages = async (options = {}) => {
    const {
        folderName = null,
        limit = null,
        randomize = false,
        createPattern = false,
        useThumbnails = false
    } = options;

    try {
        const { apiUrl } = config;
        console.log('Fetching from:', apiUrl);

        let selectedItems = [];

        // Determine the correct endpoint based on the use case
        const url = folderName
            ? `${apiUrl}/api/gallery/folders/${folderName}`
            : `${apiUrl}/api/gallery/all-images`;

        console.log('Making request to:', url);

        const response = await fetch(url);
        console.log('Response status:', response.status);

        if (!response.ok) {
            const text = await response.text();
            console.error('Error response:', text);
            throw new Error(`API request failed: ${response.status} ${text}`);
        }

        const data = await response.json();
        console.log('Received data:', data);

        const s3BaseUrl = config.mediaBaseUrl;

        if (folderName) {
            // Process specific folder
            selectedItems = data.files.map(file => ({
                thumbnailPath: `${s3BaseUrl}/${file.thumbnailKey}`,
                originalPath: `${s3BaseUrl}/${file.originalKey}`,
                type: file.type
            }));
        } else {
            // Process all images from the all-images endpoint
            selectedItems = data.files.map(file => ({
                thumbnailPath: `${s3BaseUrl}/${file.thumbnailKey}`,
                originalPath: `${s3BaseUrl}/${file.originalKey}`,
                type: file.type
            }));
        }

        // Remove any undefined or null values
        selectedItems = selectedItems.filter(Boolean);

        if (randomize) {  // Allow randomization for both folder and non-folder views
            selectedItems = selectedItems.sort(() => Math.random() - 0.5);
        }

        if (limit && !createPattern) {
            selectedItems = selectedItems.slice(0, limit);
        }

        if (createPattern && selectedItems.length > 0) {
            const baseItems = [...selectedItems];
            const pattern = [];
            const desiredLength = Math.min(baseItems.length * 2 + 4, 20);

            for (let i = 0; i < desiredLength; i++) {
                let nextItem;
                do {
                    nextItem = baseItems[Math.floor(Math.random() * baseItems.length)];
                } while (pattern.length > 0 && pattern[pattern.length - 1] === nextItem);

                pattern.push(nextItem);
            }

            return pattern;
        }

        return selectedItems;
    } catch (error) {
        console.error('Error in loadGalleryImages:', error);
        return [];
    }
};

// Helper function to validate file types
export const isValidFileType = (file) => {
    const validTypes = [
        'image/jpeg',
        'image/png',
        'image/svg+xml',
        'video/mp4',
        'video/webm',
        'video/quicktime'  // .mov files
    ];
    return validTypes.includes(file.type);
};

// Helper function to format file size
export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Helper function to get file extension
export const getFileExtension = (filename) => {
    return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
};

// Helper function to check if file is video
export const isVideo = (file) => {
    return file.type.startsWith('video/');
};

// Helper function to check if file is image
export const isImage = (file) => {
    return file.type.startsWith('image/');
};